/* VETA V2 choices: native option change only. No cart calls, global state or product edits. */
(() => {
  'use strict';
  const rootSelector = '.ov-veta-v2-page';
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function purchaseTarget(root) {
    return root?.querySelector('variant-selects') || root?.querySelector('[id^="ProductInfo-"]') || root?.querySelector('product-info');
  }
  function scrollToChoice(root) {
    const target = purchaseTarget(root);
    if (!target) return;
    const offset = 100;
    window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset), behavior: prefersReducedMotion() ? 'instant' : 'smooth'});
  }
  function preservePreview(link) {
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (!preview) return;
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin) {url.searchParams.set('preview_theme_id', preview);link.href=url.href;}
  }
  if (!customElements.get('ov-veta-v2-choices')) {
    customElements.define('ov-veta-v2-choices', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const {signal}=this.abort;
        this.root=this.closest(rootSelector);
        if (!this.root) return;
        this.querySelectorAll('a[data-ovv2-variant]').forEach(preservePreview);
        this.addEventListener('click', event => {
          const link=event.target.closest?.('a[data-ovv2-variant]');
          if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (link.dataset.available !== 'true') {event.preventDefault();return;}
          const info=this.root.querySelector('product-info');
          const picker=info?.querySelector('variant-selects');
          if (!picker || typeof info.renderProductInfo !== 'function') return; // full-page link fallback
          const groups=picker.querySelectorAll('fieldset,select');
          if (groups.length !== 1) return; // never guess a multiple-option combination
          const option=Array.from(picker.querySelectorAll('input[type="radio"]')).find(input=>input.value===link.dataset.ovv2Option);
          if (!option || option.disabled || option.classList.contains('disabled')) return;
          event.preventDefault();
          event.stopPropagation();
          const current=info.querySelector('product-form input[name="id"]') || info.querySelector('input[name="id"]');
          if (current?.value !== link.dataset.ovv2Variant || !option.checked || info.pendingRequestUrl) {
            this.querySelector('[data-ovv2-status]').textContent='Actualizando tu selección…';
            // Trigger the existing native selection path (including its stale-request guard).
            option.checked=true;
            option.dispatchEvent(new Event('change',{bubbles:true}));
          } else {
            this.sync(current.value);
            option.focus({preventScroll:true});
          }
          scrollToChoice(this.root);
        },{signal});
        document.addEventListener('change',event=>{
          if (event.target instanceof Element && event.target.matches('input[name="id"]') && this.root.contains(event.target)) this.sync(event.target.value);
        },{signal});
        document.addEventListener('variant:change',event=>{
          if (event.detail?.sectionId===this.root.querySelector('product-info')?.dataset.section) this.sync(event.detail.variant?.id);
        },{signal});
        this.sync(this.root.querySelector('product-form input[name="id"]')?.value || this.root.querySelector('product-info input[name="id"]')?.value);
      }
      disconnectedCallback(){this.abort?.abort();}
      sync(id){
        let selectedName='';
        this.querySelectorAll('[data-ovv2-card]').forEach(card=>{
          const selected=String(id)===card.dataset.ovv2Card;
          const link=card.querySelector('[data-ovv2-variant]');
          card.toggleAttribute('data-selected',selected);
          if(selected){card.dataset.selected='true';link.setAttribute('aria-current','true');selectedName=link.dataset.ovv2Option;}
          else link.removeAttribute('aria-current');
        });
        const status=this.querySelector('[data-ovv2-status]');
        if(status) status.textContent=selectedName ? 'Opción seleccionada: '+selectedName : '';
      }
    });
  }
  function prepare(root){root?.querySelectorAll('[data-ovv2-related]').forEach(preservePreview);}
  document.querySelectorAll(rootSelector).forEach(prepare);
  document.addEventListener('shopify:section:load',event=>prepare(event.target.closest(rootSelector)));
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('[data-ovv2-return]');
    const root=link?.closest(rootSelector);
    if(!root || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target=purchaseTarget(root);
    if(!target)return;
    event.preventDefault();scrollToChoice(root);
    const control=target.querySelector('input:checked, select, input,button');
    control?.focus({preventScroll:true});
  });
})();
